<template>
    <div class="sidebar-right">
        <desconhecidos />
        <acoes />
        <ocupacao />
        <infos />
    </div>
</template>

<script>
import Desconhecidos from './desconhecidos/Desconhecidos.vue'
import Acoes from './acoes/Acoes.vue'
import Ocupacao from './ocupacao/Ocupacao.vue'
import Infos from './infos/Infos.vue'

export default {
    components: {
        Desconhecidos,
        Acoes,
        Ocupacao,
        Infos
    }
}
</script>

<style>
    .sidebar-right {
        flex-basis: 60px;
        order: 2;
        
    }

    @media (min-width: 1154px) {
        .sidebar-right {
            min-width: 200px;
            flex-basis: 200px;
            order: 3;
        }
    }
    
</style>
